import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import config from '../../config/index';
import AnalyticsUtil from '../../utils/AnalyticsUtil';
import NumberUtils from '../../utils/NumberUtils';

class CompanyListCard extends React.Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this.checkKeyPress = this.checkKeyPress.bind(this);
    this.state = {
      selector: '',
    };
  }

  componentDidMount() {
    AnalyticsUtil.analyticAction(
      config.analytics.analytics_experience_view,
      config.analytics.analytics_event_method_appeared,
      'PageLoaded'
    );
    if (this.props.index === 0) {
      this.refs.listSelector.focus();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.index === 0 && this.props.isButton) {
      this.refs.listSelector.focus();
    }
  }

  onClick() {
    this.props.onClick(this.props.data);
  }

  getAccountDisplayNumber() {
    let sortcode = _.split(this.props.data.sort_code, '-');
    sortcode = NumberUtils.formatSortCode(sortcode[0]);
    const accountNumber = this.props.data.account_number;
    return `${sortcode} | ${accountNumber}`;
  }

  checkKeyPress(e) {
    if (e.which === 40 || e.keyCode === 40) {
      if (document.activeElement.nextSibling) {
        document.activeElement.nextSibling.focus();
      }
    } else if (e.which === 38 || e.keyCode === 38) {
      if (document.activeElement.previousSibling) {
        document.activeElement.previousSibling.focus();
      }
    } else if (e.which === 13 || e.keyCode === 13) {
      this.onClick();
      e.preventDefault();
    }
  }

  render() {
    const selectedIndex = `selector${this.props.index}`;
    const className =
      this.props.selectedData !== '' &&
      this.props.selectedData.biller_id === this.props.data.biller_id
        ? 'c-lookup__result__list__itemwrapper  active'
        : 'c-lookup__result__list__itemwrapper';
    return (
      <li id={selectedIndex} className={className}>
        <a
          href="javascript:void(0)"
          ref="listSelector"
          className="c-lookup--result__list__item"
          onClick={this.onClick}
        >
          <p className="c-lookup--result__list__item__data">
            {this.props.data.display_name}
          </p>
          <p className="c-lookup--result__list__item__data">
            {this.getAccountDisplayNumber()}
          </p>
        </a>
      </li>
    );
  }
}

CompanyListCard.propTypes = {
  content: PropTypes.object,
  index: PropTypes.number,
  onClick: PropTypes.func,
  data: PropTypes.object,
  isButton: PropTypes.bool,
  selectedData: PropTypes.object,
};
CompanyListCard.defaultProps = {
  content: {},
  index: '',
  isButton: false,
  data: {},
  selectedData: {},
};
export default CompanyListCard;
